const API_ENDPOINTS = {
    // Auth-формы (вход/регистрация/восстановление пароля). Пока заглушки —
    // слайсы используют simulateSendForm; боевые blade-формы постят на
    // web-роуты route('login') / route('register') / route('password.email').
    // Контракты запроса/ответа — см. `src/store/types/loginFormTypes.ts`,
    // `registerFormTypes.ts`, `forgotPasswordFormTypes.ts`.
    login: `api/auth/login`,
    register: `api/auth/register`,
    forgotPassword: `api/auth/forgot-password`,

    recommendations: `api/recommends/tests/`,
    recommendationsTracker: `api/recommends/tests/save`,
    tests: `api/`,
    results: `api/attempts`,
    lastAttempt: `api/attempts/last/`,
    historyResults: `/api/attempts/history/`,
    reportForm: `api/questions/report`,
    ratingForm: `api/attempts/rating`,

    // Показатели качества теста (попап по бейджу «Качество проверено»).
    // Контракт — см. `src/store/types/testQualityTypes.ts`.
    testQuality: (testId: number) => `api/tests/${testId}/quality`,

    // Настройки пользователя (модалка «Настройки» в профиле).
    // Контракт запроса/ответа — см. `src/store/types/settingsFormTypes.ts`.
    profileSettings: `api/profile/settings`,
    accountSettings:            `api/account/settings`,
    accountResendVerification:  `api/account/resend-verification`,
    accountDelete:              `api/account`,

    // Аватар профиля (upload + текущий URL).
    // Контракт — см. `src/store/types/profileAvatarTypes.ts`.
    profileAvatar:   `api/profile/avatar`,

    // Карточки раздела «Я» в профиле (характеристики пользователя).
    // Контракт — см. `src/store/types/meCardsTypes.ts`.
    profileMeCards:  `api/profile/me-cards`,

    // Вкладка «Мои тесты» + избранное.
    // Контракт — см. `docs/API_MY_TESTS.md`.
    myTests:          `api/profile/my-tests`,
    addFavoriteTest:  `api/profile/favorites/`,
    removeFavoriteTest: `api/profile/favorites/`,

    checkDomain: `api/wgt/domains/check/`,
    checkWidgetExisting: `api/wgt/tests/`,
    postWidget: `api/wgt`,
    getWidgetsList: `api/wgt`,
    getDomainList: `api/wgt/domains`,
    postNewDomain: `api/wgt/domains`,
    deleteDomain: `api/wgt/domains/`,
    deleteWidget: `api/wgt/`,
    checkWidgetAccess: `api/wgt/tests/access/`,

    // Показ баннера (floc/sbsl) — маячок в link-tracker.
    // Контракт: POST { code: 'floc'|'sbsl', is_visible: boolean }.
    bannerImpression: `api/link-tracker/impression`,

};

export default API_ENDPOINTS;

